import React from 'react';
import { Icon } from '@/presentation/reusables/components/Icon';
import { SErrorMessage } from './styled';

type ErrorMessageProps = {
  message?: string;
};

export const ErrorMessage = ({ message }: ErrorMessageProps) => (
  <SErrorMessage>
    <Icon name="warning" />
    <p>{message}</p>
  </SErrorMessage>
);
